import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Plus } from "react-bootstrap-icons";
// import { NavLink } from "react-router-dom";
// import {
//   pathNewsSubAll,
//   pathNewsSubImportant,
//   pathNewsSubPinned,
// } from "../../../common/config/vars";
// import { getAttachImgSrc, IDemFile } from "../logics/demandFiles";
import IconDemDone from "../../../common/assets/images/demandDone.png";
import "../styles/demandDone.css";

interface IDone {
  setClose: React.Dispatch<React.SetStateAction<boolean>>;
  text: string;
  wait: number;
}

export const Done = ({ setClose, text, wait = -1 }: IDone) => {
  const [sec, setSec] = useState(wait);
  useEffect(() => {
    if (wait === -1) return;
    const timer = setInterval(() => {
      setSec((s) => s - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    console.log("SEC:", sec);
    if (sec === 0) setClose(true);
  }, [sec]);
  return (
    <>
      <div
        className="row col-12 d-flex m-auto pl-0 pr-0"
        style={{ paddingBottom: "20px" }}
      >
        <div hidden={wait === -1} style={{ fontSize: "10px" }}>
          Окно закроется через {sec}
        </div>
        <Button
          onClick={() => setClose(true)}
          variant="default"
          className="bg-white ml-auto p-1 rounded-circle"
        >
          <Plus className="icon-close" />
        </Button>
      </div>
      <img
        src={IconDemDone}
        alt="Операция завершена успешно"
        className="img-done"
      />
      <div className="text-done">{text}</div>
    </>
  );
};
